<template>
	<div>
		<table class="table table-striped">
			<thead>
				<tr>
					<td></td>
					<td
						v-for="(manobra, idxM) in filteredManobras"
						:key="'manobra2' + idxM"
						class="text-center"
					>
						<div class="btn-group">
							<button
								type="button"
								class="btn btn-default dropdown-toggle"
								style="
									padding: 0;
									border: 0px;
									background: transparent;
									display: flex;
									align-items: center;
									justify-content: center;
								"
								data-toggle="dropdown"
								aria-haspopup="true"
								aria-expanded="false"
							>
								<b>{{ manobra.descricao | upper }}</b>
								<span class="caret" style="margin-left: 5px"></span>
							</button>
							<ul class="dropdown-menu" style="min-width: 0px">
								<li>
									<a
										href="#"
										style="display: flex; align-items: center"
										@click.prevent="$emit('check-usuarios-manobra', manobra)"
										><svg
											xmlns="http://www.w3.org/2000/svg"
											fill="none"
											viewBox="0 0 24 24"
											stroke-width="1.5"
											stroke="currentColor"
											style="width: 12px; margin-right: 6px"
										>
											<path
												stroke-linecap="round"
												stroke-linejoin="round"
												d="m4.5 12.75 6 6 9-13.5"
											/>
										</svg>
										Selecionar todos</a
									>
								</li>
								<li>
									<a
										href="#"
										style="display: flex; align-items: center"
										@click.prevent="$emit('remove-usuarios-manobra', manobra)"
										><svg
											xmlns="http://www.w3.org/2000/svg"
											fill="none"
											viewBox="0 0 24 24"
											stroke-width="1.5"
											stroke="currentColor"
											style="width: 12px; margin-right: 6px"
										>
											<path
												stroke-linecap="round"
												stroke-linejoin="round"
												d="M6 18 18 6M6 6l12 12"
											/>
										</svg>
										Remover seleção</a
									>
								</li>
								<li>
									<a
										href="#"
										style="display: flex; align-items: center"
										@click.prevent="$emit('delete-manobra', manobra)"
									>
										<svg
											xmlns="http://www.w3.org/2000/svg"
											fill="none"
											viewBox="0 0 24 24"
											stroke-width="1.5"
											stroke="currentColor"
											style="width: 12px; margin-right: 6px"
										>
											<path
												stroke-linecap="round"
												stroke-linejoin="round"
												d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
											/>
										</svg>
										Remover manobra
									</a>
								</li>
							</ul>
						</div>
					</td>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(tripulante, idxT) in tripulacao" :key="'tripulante' + idxT">
					<td style="width: 400px">
						<div>
							<div class="btn-group">
								<button
									type="button"
									class="btn btn-default dropdown-toggle"
									style="
										padding: 0;
										border: 0px;
										background: transparent;
										display: flex;
										align-items: center;
										justify-content: center;
									"
									data-toggle="dropdown"
									aria-haspopup="true"
									aria-expanded="false"
								>
									<b>{{ tripulante.trigrama }} - {{ tripulante.nome }}</b>
									<span class="caret" style="margin-left: 5px"></span>
								</button>
								<ul class="dropdown-menu" style="min-width: 0px">
									<li>
										<a
											href="#"
											style="display: flex; align-items: center"
											@click.prevent="
												$emit('check-manobras-usuario', tripulante)
											"
											><svg
												xmlns="http://www.w3.org/2000/svg"
												fill="none"
												viewBox="0 0 24 24"
												stroke-width="1.5"
												stroke="currentColor"
												style="width: 12px; margin-right: 6px"
											>
												<path
													stroke-linecap="round"
													stroke-linejoin="round"
													d="m4.5 12.75 6 6 9-13.5"
												/>
											</svg>
											Selecionar todos</a
										>
									</li>
									<li>
										<a
											href="#"
											style="display: flex; align-items: center"
											@click.prevent="
												$emit('remove-manobras-usuario', tripulante)
											"
											><svg
												xmlns="http://www.w3.org/2000/svg"
												fill="none"
												viewBox="0 0 24 24"
												stroke-width="1.5"
												stroke="currentColor"
												style="width: 12px; margin-right: 6px"
											>
												<path
													stroke-linecap="round"
													stroke-linejoin="round"
													d="M6 18 18 6M6 6l12 12"
												/>
											</svg>
											Remover seleção</a
										>
									</li>
								</ul>
							</div>
						</div>
						<small style="font-size: 9px">{{
							tripulante.funcao | upper
						}}</small>
					</td>
					<td
						v-for="(manobra, idxM) in filteredManobras"
						:key="'manobra' + idxM"
						class="text-center pointer"
						style="vertical-align: middle"
						@click="
							$emit('check-manobra', {
								id_usuario: tripulante.id_usuario,
								id_manobra: manobra.id
							})
						"
					>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							fill="none"
							viewBox="0 0 24 24"
							stroke-width="1.5"
							stroke="currentColor"
							style="width: 20px; color: green"
							v-if="manobraSelecionada(tripulante.id_usuario, manobra.id)"
						>
							<path
								stroke-linecap="round"
								stroke-linejoin="round"
								d="m4.5 12.75 6 6 9-13.5"
							/>
						</svg>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							fill="none"
							viewBox="0 0 24 24"
							stroke-width="1.5"
							stroke="currentColor"
							style="width: 20px; color: red"
							v-else
						>
							<path
								stroke-linecap="round"
								stroke-linejoin="round"
								d="M6 18 18 6M6 6l12 12"
							/>
						</svg>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
export default {
	props: {
		manobras: {
			type: Array,
			default: () => []
		},
		tripulacao: {
			type: Array,
			default: () => []
		},
		filter: {
			type: Function,
			default: () => true
		},
		relation: {
			type: Array,
			default: () => []
		}
	},
	computed: {
		filteredManobras() {
			return this.manobras.filter(this.filter)
		}
	},
	methods: {
		manobraSelecionada(usuarioId, manobraId) {
			return this.relation.some(
				(item) => item.id_manobra == manobraId && item.id_usuario == usuarioId
			)
		}
	}
}
</script>